import styled, { keyframes } from 'styled-components';
import * as S from '../styled';

const fadeIn = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

export const Section = styled(S.Section)`
    padding-bottom: 0;
`;

export const TabContent = styled.div`
    display: grid;
    grid-template-columns: 50% 1fr;
    grid-template-rows: min-content min-content 1fr;
    grid-template-areas: 
        "title img"
        "text img"
        "link img";
    grid-gap: 20px 10vw;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 352px;
    animation: ${fadeIn} 0.5s linear forwards;

    @media(max-width: ${S.breakePoints.tablet}) {
        grid-template-columns: 1fr;
        grid-template-rows: min-content 300px min-content 1fr;
        grid-template-areas: 
            "title"
            "img"
            "text"
            "link";
        height: 510px;
    }

    @media(max-width: ${S.breakePoints.tablet}) {
        height: 580px;
    }
`;

export const TabTitle = styled(S.DataTitle)`
    margin: 0;
    grid-area: title;
`;

export const TabText = styled(S.DataText)`
    margin: 0;
    grid-area: text;
`;

export const TabImgWrap = styled(S.ImgWrap)`
    grid-area: img;
    height: 100%;
`;

export const TabLink = styled(S.DataLink)`
    margin-top: 0;
`;
